import React, { useState, useEffect } from "react";

export default function GEOGRAPHYtest(props) {
  const correctAnswers = [3, 1, 3, 0, 2, 0, 0, 0, 0, 2, 0, 2, 0, 0, 3, 1, 1, 0, 0, 0, 0, 1, 3, 0, 3];
  const que = {
    q1: {
      string: "1. Which river is known as the 'Ganga of the South'?",
      options: ["Yamuna", "Godavari", "Krishna", "Kaveri"],
      ans: 3
    },
    q2: {
      string: "2. Which is the largest state in India by area?",
      options: ["Uttar Pradesh", "Rajasthan", "Madhya Pradesh", "Maharashtra"],
      ans: 1
    },
    q3: {
      string: "3. Which of the following countries is NOT located in South Asia?",
      options: ["India", "Nepal", "Sri Lanka", "Thailand"],
      ans: 3
    },
    q4: {
      string: "4. The Thar Desert is located primarily in which Indian state?",
      options: ["Rajasthan", "Gujarat", "Haryana", "Punjab"],
      ans: 0
    },
    q5: {
      string: "5. What is the capital city of Australia?",
      options: ["Sydney", "Melbourne", "Canberra", "Brisbane"],
      ans: 2
    },
    q6: {
      string: "6. Which of the following is the largest rainforest in the world?",
      options: ["Amazon Rainforest", "Congo Rainforest", "Sundarbans", "Daintree Rainforest"],
      ans: 0
    },
    q7: {
      string: "7. The 'Great Barrier Reef' is located in which country?",
      options: ["Australia", "Brazil", "Indonesia", "Mexico"],
      ans: 0
    },
    q8: {
      string: "8. Which of the following countries is known for its tulip fields?",
      options: ["Netherlands", "Canada", "Russia", "Japan"],
      ans: 0
    },
    q9: {
      string: "9. What is the largest desert in the world?",
      options: ["Sahara Desert", "Arabian Desert", "Gobi Desert", "Kalahari Desert"],
      ans: 0
    },
    q10: {
      string: "10. Which river is known as the 'Lifeline of Rajasthan'?",
      options: ["Yamuna", "Narmada", "Luni", "Ganga"],
      ans: 2
    },
    q11: {
      string: "11. Mount Everest is located in which mountain range?",
      options: ["Himalayas", "Andes", "Rockies", "Alps"],
      ans: 0
    },
    q12: {
      string: "12. Which of the following is NOT a tributary of the river Ganga?",
      options: ["Yamuna", "Brahmaputra", "Kaveri", "Ghaghara"],
      ans: 2
    },
    q13: {
      string: "13. The 'City of Lakes' in India refers to which city?",
      options: ["Udaipur", "Jaipur", "Jodhpur", "Bhopal"],
      ans: 0
    },
    q14: {
      string: "14. Which of the following states in India is known as the 'Land of Five Rivers'?",
      options: ["Punjab", "Haryana", "Rajasthan", "Uttar Pradesh"],
      ans: 0
    },
    q15: {
      string: "15. Which of the following is NOT a type of desert?",
      options: ["Semi-arid desert", "Tropical desert", "Arctic desert", "Monsoon desert"],
      ans: 3
    },
    q16: {
      string: "16. The 'Western Ghats' are also known by which other name?",
      options: ["Eastern Ghats", "Sahyadri Range", "Aravalli Range", "Vindhya Range"],
      ans: 1
    },
    q17: {
      string: "17. Which river is known as the 'Dakshin Ganga'?",
      options: ["Godavari", "Kaveri", "Krishna", "Tungabhadra"],
      ans: 1
    },
    q18: {
      string: "18. The 'Siachen Glacier', the world's highest battlefield, is located in which mountain range?",
      options: ["Himalayas", "Andes", "Rockies", "Alps"],
      ans: 0
    },
    q19: {
      string: "19. Which of the following states in India is known as the 'Land of Forests'?",
      options: ["Madhya Pradesh", "Uttarakhand", "Assam", "Chhattisgarh"],
      ans: 0
    },
    q20: {
      string: "20. Which of the following Indian states has the highest forest cover?",
      options: ["Madhya Pradesh", "Maharashtra", "Uttarakhand", "Arunachal Pradesh"],
      ans: 0
    },
    q21: {
      string: "21. Which is the longest river in India?",
      options: ["Ganga", "Yamuna", "Brahmaputra", "Godavari"],
      ans: 2
    },
    q22: {
      string: "22. The 'Sundarbans', famous for its mangrove forests, is located in which country?",
      options: ["India", "Bangladesh", "Myanmar", "Thailand"],
      ans: 1
    },
    q23: {
      string: "23. Which desert is also known as the 'White Desert'?",
      options: ["Sahara Desert", "Thar Desert", "Arabian Desert", "Rann of Kutch"],
      ans: 3
    },
    q24: {
      string: "24. Which of the following states in India is known for its backwaters?",
      options: ["Kerala", "Tamil Nadu", "Andhra Pradesh", "Telangana"],
      ans: 0
    },
    q25: {
      string: "25. The 'Deccan Plateau' is located in which part of India?",
      options: ["Northern India", "Eastern India", "Western India", "Southern India"],
      ans: 3
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };
  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>GEOGRAPHY <span>KNOWLEDGE</span> Test</h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
